interface DetailExternalLinkProps {
  children: string;
  href: string;
  /** GTM `data-track` id, forwarded onto the anchor. */
  dataTrack?: string;
  /** GTM `data-track-label`, forwarded onto the anchor. */
  dataTrackLabel?: string;
  /** GTM `data-track-context`, forwarded onto the anchor. */
  dataTrackContext?: string;
}

export function DetailExternalLink({
  children,
  href,
  dataTrack,
  dataTrackLabel,
  dataTrackContext,
}: DetailExternalLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-track={dataTrack}
      data-track-label={dataTrackLabel}
      data-track-context={dataTrackContext}
      className="mdc-btn mdc-btn--link mdc-btn--md w-full justify-start py-0"
    >
      <span className="min-w-0 overflow-hidden py-8 text-ellipsis">
        {children}
      </span>
      <span
        aria-hidden="true"
        className="inline-flex size-14 shrink-0 items-center justify-center rounded-[3px] border-2 border-current text-[10px] leading-none font-bold"
      >
        ↗
      </span>
    </a>
  );
}
